interface IProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Alert: React.FC<IProps> = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return <div className="alert-overlay fadeInDown">{children}</div>;
};
